<script lang="ts">
    import {authBlobUrl} from "../Auth";
    import InView from "./InView.svelte";
    export let src: string
    export let alt: string = null
    export let crossorigin: string = null
    export let height: string = null
    export let ismap: string = null
    export let loading: string = null
    export let longdesc: string = null
    export let referrerpolicy: string = null
    export let sizes: string = null
    export let srcset: string = null
    export let usemap: string = null
    export let width: string = null
    export let imageClass: string = null
</script>
<InView inline>{#await authBlobUrl(src)}{""}{:then url}{#if url}<img
    src="{url}"
    {alt}
    {crossorigin}
    {height}
    {ismap}
    {loading}
    {longdesc}
    {referrerpolicy}
    {sizes}
    {srcset}
    {usemap}
    {width}
    class="{imageClass}"
>{/if}{:catch error}{""}{/await}</InView>
